"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var fadeEffect = (0, _ykbStyledComponents.css)(["animation-duration:", ";animation-fill-mode:both;animation-timing-function:cubic-bezier(0.55,0,0.55,0.2);"], function (props) {
  return props.theme.animation.base.duration;
});
var rcDialogFadeIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;}100%{opacity:1;}"]);
var rcDialogFadeOut = (0, _ykbStyledComponents.keyframes)(["0%{opacity:1;}100%{opacity:0;}"]);
var rcDialogZoomIn = (0, _ykbStyledComponents.keyframes)(["0%{opacity:0;transform:scale(0.2);}100%{opacity:1;transform:scale(1);}"]);
var rcDialogZoomOut = (0, _ykbStyledComponents.keyframes)(["0%{transform:scale(1);}100%{opacity:0;transform:scale(0.2);}"]);
function teslaPositionCalculator(width) {
  var teslaWidth = '770px';
  return "calc((100% - ".concat(teslaWidth, " - ").concat(width, ") / 2)");
}
var halfSparxSidePanelWidth = '200px',
  sparxSidePanelMaximumWidth = '1500px',
  halfHarmoniOneSidePanelWidth = '225px',
  harmoniOneSidePanelMaximumWidth = '1446px',
  halfHarmoniTwoSidePanelWidth = '404px',
  harmoniTwoSidePanelMaximumWidth = '1088px',
  halfHarmoniCCOneSidePanelWidth = '224px',
  harmoniCCOneSidePanelMaximumWidth = '1431px',
  halfHarmoniCCTwoSidePanelWidth = '402px',
  harmoniCCTwoSidePanelMaximumWidth = '1071px';
var ModalStyles = (0, _ykbStyledComponents.createGlobalStyle)([".sparx-app-container{&[class*=\"only-active-tab\"]{position:relative;}}.", "{position:relative;width:auto;margin:", ";top:", ";", " &[class*=\"only-active-tab\"]{top:50%;transform:translateY(-50%);}}.", "-mask{position:fixed;top:0;right:0;left:0;bottom:0;background-color:", ";height:100%;filter:alpha(opacity=50);z-index:", ";&[class*=\"only-active-tab\"]{position:absolute;height:100vh;}}.", "-mask.", "-mask-hidden{display:none;}.", "-fade-enter,.", "-fade-appear{", " opacity:0;animation-play-state:paused;}.", "-fade-leave{", " animation-play-state:paused;}.", "-fade-enter-active,.", "-fade-appear-active{animation-name:", ";animation-play-state:running;}.", "-fade-leave-active{animation-name:", ";animation-play-state:running;}.", "-wrap{position:", ";overflow:auto;top:0;right:0;bottom:0;left:0;z-index:", ";outline:0;&[class*=\"only-active-tab\"]{position:absolute;height:100vh;}&.modal-drag-start{user-select:none;overflow:hidden;}}.", "-title{margin:0;font-size:", ";font-weight:", ";color:", ";}.", "-content{position:relative;background-color:", ";border:none;border-radius:", ";background-clip:padding-box;}.", "-close{cursor:pointer;border:0;background:transparent;position:absolute;right:", ";top:", ";outline:none;line-height:1;color:", ";filter:alpha(opacity=30);opacity:0.3;text-decoration:none;&:hover{opacity:0.5;filter:alpha(opacity=50);color:", ";text-decoration:none;}}.", "-header{padding:", ";border-radius:", ";background:", ";color:", ";border-bottom:", ";cursor:grabbing;}.", "--noheader{.", "-header{display:none;}}.", "-body{display:", ";gap:10px;padding:", ";> div > p:first-child{margin-top:0;}> div > p:last-child{margin-bottom:0;}text-align:", ";overflow:auto;max-height:calc(100vh - 323px);-webkit-overflow-scrolling:touch;text-align:", ";> .", "-children-wrapper{width:100%;}}.", "-footer{border-top:", ";padding:", ";padding-top:", ";text-align:", ";display:", ";border-radius:", ";button{margin-bottom:0;width:", ";}> button:last-child{margin-right:0;}}.", "-zoom-enter,.", "-zoom-appear{opacity:0;animation-duration:", ";animation-fill-mode:both;animation-timing-function:", ";animation-play-state:paused;&[class*='-active']{animation-name:", ";animation-play-state:running;}}.", "-zoom-leave{animation-duration:", ";animation-fill-mode:both;animation-timing-function:", ";animation-play-state:paused;&[class*='-active']{animation-name:", ";animation-play-state:running;}}@media (min-width:768px){.", "{width:", ";margin:", " auto;}.", ".", "--xsmall{width:", ";}.", ".", "--small{width:", ";}.", ".", "--large{width:auto;padding:", ";}.", ".", "--xlarge{width:auto;padding:", ";}.", ".", "--maximum{width:auto;padding:", ";}.", ".", "--center{width:", ";}.", "--page-centered{left:", ";}.", "--page-centered-hmn-half{left:", ";}.", "--page-centered-hmn-full{left:", ";}.", "--page-centered-hmn-cc-half{left:", ";}.", "--page-centered-hmn-cc-full{left:", ";}}@media (min-width:992px){.", ".", "--large{width:", ";padding:0;}}@media (min-width:1200px){.", ".", "--xlarge{width:", ";padding:0;}}@media (min-width:1690px){.", ".", "--maximum{width:", ";padding:0;}}@media (max-width:2090px){.", ".", "--maximum.", "--page-centered{width:", ";padding:", ";}.", ".", "--maximum.", "--page-centered-hmn-half{width:", ";padding:", ";}.", ".", "--maximum.", "--page-centered-hmn-full{width:", ";padding:", ";}.", ".", "--maximum.", "--page-centered-hmn-cc-half{width:", ";padding:", ";}.", ".", "--maximum.", "--page-centered-hmn-cc-full{width:", ";padding:", ";}}@media (min-width:768px){div.sparx-tesla-open-render-on-body div[role='dialog'],body.sparx-tesla-open div.renderOnBody div[role='dialog'],div.sparx-tesla-open-in-sparx-process div[role='dialog']{left:", ";&:has(>.", ".", "--default){right:", ";}&:has(>.", ".", "--center){right:", ";}&:has(>.", ".", "--xsmall){right:", ";}&:has(>.", ".", "--small){right:", ";}@media (min-width:992px){&:has(>.", ".", "--large){left:unset;right:", ";}}@media (min-width:1200px){&:has(>.", ".", "--xlarge){left:unset;right:", ";}&:has(>.", ".", "--maximum){left:unset;right:", ";width:", ";padding:0;}}@media (min-width:1690px){&:has(>.", ".", "--maximum){left:unset;right:", ";width:", ";padding:0;}}}}.", ".", "--custom-height .", "-body{height:", ";max-height:unset;}"], function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.margin;
}, function (props) {
  return props.theme.modal.top;
}, function (props) {
  return props.isVerticalCenter && "\n    position: relative;\n    width: auto;\n    margin: ".concat(function (props) {
    return props.theme.modal.margin;
  }, ";\n    top: 50%;\n    transform: translateY(-50%) !important;\n    ");
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.mask.backgroundColor;
}, function (props) {
  return props.theme.modal.mask.zIndex;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, fadeEffect, function (props) {
  return props.prefixCls;
}, fadeEffect, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, rcDialogFadeIn, function (props) {
  return props.prefixCls;
}, rcDialogFadeOut, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.onlyActiveTab ? 'absolute' : 'fixed';
}, function (props) {
  return props.theme.modal.zIndex;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.title.fontSize;
}, function (props) {
  return props.theme.modal.title.fontWeight;
}, function (props) {
  return props.theme.modal.title.color;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.content.backgroundColor;
}, function (props) {
  return props.theme.modal.borderRadius;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.close.right;
}, function (props) {
  return props.theme.modal.close.top;
}, function (props) {
  return props.theme.modal.close.neutral12;
}, function (props) {
  return props.theme.modal.close.neutral12;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.closable ? "".concat(props.theme.modal.header.verticalPadding, " ").concat(props.theme.modal.header.whenClosableRightPadding, " ").concat(props.theme.modal.header.verticalPadding, " ").concat(props.theme.modal.header.horizontalPadding) : "".concat(props.theme.modal.header.verticalPadding, " ").concat(props.theme.modal.header.horizontalPadding);
}, function (props) {
  return "".concat(props.theme.modal.borderRadius, " ").concat(props.theme.modal.borderRadius, " 0 0");
}, function (props) {
  return props.theme.modal.header.backgroundColor;
}, function (props) {
  return props.theme.modal.header.color;
}, function (props) {
  return !props.centered ? "".concat(props.theme.border.width, " ").concat(props.theme.border.style, " ").concat(props.theme.divider.borderColor) : 'none';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return !props.centered && 'flex';
}, function (props) {
  return props.centered && props.closable ? props.theme.modal.body.centerPadding : props.closable && !props.centered && !props.title ? props.theme.modal.body.noTitlePadding : props.theme.modal.body.padding;
}, function (props) {
  return props.centered ? 'center' : 'left';
}, function (props) {
  return props.centered ? 'center' : 'left';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return !props.centered ? "".concat(props.theme.border.width, " ").concat(props.theme.border.style, " ").concat(props.theme.divider.borderColor) : 'none';
}, function (props) {
  return props.centered ? props.theme.modal.footer.centerPadding : props.theme.modal.footer.padding;
}, function (props) {
  return props.centered && 0;
}, function (props) {
  return props.centered ? 'center' : 'right';
}, function (props) {
  return props.centered && 'flex';
}, function (props) {
  return "0 0 ".concat(props.theme.modal.borderRadius, " ").concat(props.theme.modal.borderRadius);
}, function (props) {
  return props.centered && '100%';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.animation.base.duration;
}, function (props) {
  return props.theme.animation.ease.outCirc;
}, rcDialogZoomIn, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.animation.base.duration;
}, function (props) {
  return props.theme.animation.ease.inCirc;
}, rcDialogZoomOut, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.default;
}, function (props) {
  return props.theme.modal.margin;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.xsmall;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.small;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.centered;
}, function (props) {
  return props.prefixCls;
}, halfSparxSidePanelWidth, function (props) {
  return props.prefixCls;
}, halfHarmoniOneSidePanelWidth, function (props) {
  return props.prefixCls;
}, halfHarmoniTwoSidePanelWidth, function (props) {
  return props.prefixCls;
}, halfHarmoniCCOneSidePanelWidth, function (props) {
  return props.prefixCls;
}, halfHarmoniCCTwoSidePanelWidth, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.large;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.xlarge;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.modal.width.maximum;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, sparxSidePanelMaximumWidth, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, harmoniOneSidePanelMaximumWidth, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, harmoniTwoSidePanelMaximumWidth, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, harmoniCCOneSidePanelMaximumWidth, function (props) {
  return props.theme.gutter;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, harmoniCCTwoSidePanelMaximumWidth, function (props) {
  return props.theme.gutter;
}, function (props) {
  return ['xsmall', 'small', 'default'].includes(props.size) && 'unset';
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'default' && teslaPositionCalculator(props.theme.modal.width[props.size]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.centered && teslaPositionCalculator(props.theme.modal.width.centered);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'xsmall' && teslaPositionCalculator(props.theme.modal.width[props.size]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'small' && teslaPositionCalculator(props.theme.modal.width[props.size]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'large' && teslaPositionCalculator(props.theme.modal.width[props.size]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'xlarge' && teslaPositionCalculator(props.theme.modal.width[props.size]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'maximum' && teslaPositionCalculator(props.theme.modal.width['xlarge']);
}, function (props) {
  return props.theme.modal.width.xlarge;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.size === 'maximum' && teslaPositionCalculator(props.theme.modal.width['maximum']);
}, function (props) {
  return props.theme.modal.width.maximum;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return typeof props.height === 'number' ? "".concat(props.height, "px") : props.height;
});
var MemoizedModalStyles = /*#__PURE__*/_react.default.memo(ModalStyles, function (prevProps, nextProps) {
  return prevProps.prefixCls === nextProps.prefixCls;
});
var Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    size = _ref.size,
    height = _ref.height,
    closable = _ref.closable,
    type = _ref.type,
    title = _ref.title,
    centered = _ref.centered,
    modalCenter = _ref.modalCenter,
    isVerticalCenter = _ref.isVerticalCenter,
    onlyActiveTab = _ref.onlyActiveTab;
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  var prefixV2 = centered ? "".concat(prefix, "-center") : prefix;
  var prefixV3 = !title ? "".concat(prefixV2, "-no-title") : prefixV2;
  var prefixV4 = !closable ? "".concat(prefixV3, "-no-closable") : prefixV3;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MemoizedModalStyles, {
    theme: theme,
    prefixCls: prefixV4,
    size: size,
    height: height,
    closable: closable,
    type: type,
    title: title,
    centered: centered,
    modalCenter: modalCenter,
    isVerticalCenter: isVerticalCenter,
    onlyActiveTab: onlyActiveTab
  }), children(prefixV4));
};
var StyledModal = exports.StyledModal = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-13x0jov-0"
})([""]);